import { FC } from "react";
import {
  ToggleModalButton,
  ToggleModalButtonProps,
} from "../../../components/Interaction/Buttons/ToggleModalButton";
import { SECTION_TITLE_STYLES } from "./styles";

type SectionProps = {
  title: string;
  buttonProperties?: ToggleModalButtonProps;
};

export const Section: FC<React.PropsWithChildren<SectionProps>> = ({
  title,
  buttonProperties,
  children,
}) => {
  return (
    <section>
      <div className="mb-5 flex items-center">
        <h2 className={SECTION_TITLE_STYLES}>{title}</h2>
        {buttonProperties && <ToggleModalButton {...buttonProperties} />}
      </div>
      {children}
    </section>
  );
};
